import { createContext, useContext, useState } from 'react';

export const DEFAULT_FILTERS = {
  propertyTypes: [],
  startDate: null,
  endDate: null,
  guests: { adults: 0, children: 0, babies: 0, pets: 0 },
  minPrice: 0,
  maxPrice: 200000,
};

const STORAGE_KEY = 'dalal_filters';

// Sérialise les Date en ISO string pour le localStorage
const serialize = (filters) => JSON.stringify({
  ...filters,
  startDate: filters.startDate instanceof Date ? filters.startDate.toISOString() : filters.startDate,
  endDate: filters.endDate instanceof Date ? filters.endDate.toISOString() : filters.endDate,
});

const today = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

// Désérialise en réhydratant les Date depuis leur ISO string
const deserialize = (raw) => {
  try {
    const parsed = JSON.parse(raw);
    const now = today();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const startDate = parsed.startDate
      ? (new Date(parsed.startDate) < now ? now : new Date(parsed.startDate))
      : null;
    const endDate = parsed.endDate
      ? (new Date(parsed.endDate) < now ? tomorrow : new Date(parsed.endDate))
      : null;
    return {
      ...DEFAULT_FILTERS,
      ...parsed,
      startDate,
      endDate,
    };
  } catch {
    return DEFAULT_FILTERS;
  }
};

const loadFromStorage = () => {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw ? deserialize(raw) : DEFAULT_FILTERS;
};

const FiltersContext = createContext(undefined);

export function FiltersProvider({ children }) {
  const [filters, setFilters] = useState(loadFromStorage);

  const updateFilters = (next) => {
    setFilters(next);
    localStorage.setItem(STORAGE_KEY, serialize(next));
  };

  const handleFiltersChange = (partial) =>
    updateFilters({ ...filters, ...partial });

  const clearFilters = () => {
    updateFilters(DEFAULT_FILTERS);
  };

  return (
    <FiltersContext.Provider value={{ filters, handleFiltersChange, clearFilters }}>
      {children}
    </FiltersContext.Provider>
  );
}

export function useFilters() {
  const context = useContext(FiltersContext);
  if (context === undefined) {
    throw new Error('useFilters must be used within a FiltersProvider');
  }
  return context;
}
